<template>
  <v-card flat fluid class="container">
    <v-card-text class="contents">
      <AppForm label="カテゴリー">
        <v-select
          :items="poiCategoryList"
          @change="fetchSubCategoryAndResetConditions($event)"
          no-data-text="選択できるカテゴリーがありません"
          item-text="name"
          item-value="id"
          class="select"
        />
      </AppForm>
      <!-- 絞り込み条件 -->
      <POISearchConditions
        :poiSearchForm="poiSearchForm"
        :poiSubcategoryList="poiSubcategoryList"
        :loading="loading"
        @onClickTargetCondition="onClickTargetCondition"
      />
      <!-- 絞り込み条件フォームモーダル -->
      <SubcategoryListFormModal
        :poiSearchForm="poiSearchForm"
        :isShowConditionModal="isShowConditionModal"
        :selectedPoiCategoryId="poiSearchForm.categoryId"
        @closeModal="isShowConditionModal = false"
        @emptyConditions="emptyConditions"
        @onClickSave="onClickSave"
      />
      <!-- 対象エリア -->
      <TargetArea
        :poiSearchForm="poiSearchForm"
        @onClickTargetArea="onClickTargetArea"
      />
      <!-- 対象エリアフォームモーダル -->
      <TargetAreaFormModal
        :isShowAreaModal="isShowAreaModal"
        :poiSearchForm="poiSearchForm"
        @closeModal="isShowAreaModal = false"
        @onClickSave="onClickSave"
      />
    </v-card-text>
    <v-layout class="setting-area-footer">
      <v-flex xs4 class="locationList-length-text">
        <h2>該当地点数: {{ locationCount }} 地点</h2>
      </v-flex>
      <v-flex v-if="isCategorySelected && locationCount === 0" xs12 mt-2 ml-2>
        <p class="warning-text">
          条件に該当する地点がありません。絞り込み条件または、対象エリアを変更して下さい。
        </p>
      </v-flex>
      <v-flex v-if="isCategorySelected && simulationValid" xs12 mt-2 ml-2>
        <p class="warning-text">
          シミュレーションへ取り込みができる地点数の上限は20000地点です。<br />
          条件を絞り込んで、20000地点以下になるように調整をしてください。
        </p>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { POICategoryRepository } from '@/models/POICategoryRepository'
import POISearchConditions from './POISearchConditions'
import TargetArea from './TargetArea'
import SubcategoryListFormModal from './SubcategoryListFormModal'
import TargetAreaFormModal from './TargetAreaFormModal'

export default {
  name: 'EditLocationGroup',
  components: {
    POISearchConditions,
    TargetArea,
    SubcategoryListFormModal,
    TargetAreaFormModal,
  },
  props: {
    poiSearchForm: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: Object,
      default: () => {},
    },
    locationCount: {
      type: Number,
      default: 0,
    },
    simulationValid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      poiCategoryList: [],
      poiSubcategoryList: [],
      isShowAreaModal: false,
      isShowConditionModal: false,
      loading: false,
      isCategorySelected: false,
    }
  },
  watch: {
    poiSearchForm: {
      handler: function() {
        this.$emit('change')
      },
      deep: true,
    },
  },
  async created() {
    this.poiCategoryList = await POICategoryRepository.getCategory()
  },
  methods: {
    async fetchSubCategoryAndResetConditions(categoryId) {
      this.loading = true
      this.poiSubcategoryList = await POICategoryRepository.getSubcategory(
        categoryId,
      )
      this.loading = false
      this.$nextTick(() => {
        this.poiSearchForm.categoryId = categoryId
        this.poiSearchForm.resetConditions()
        this.isCategorySelected = true
      })
    },
    emptyConditions() {
      this.poiSearchForm.emptyConditions()
    },
    onClickTargetArea() {
      this.isShowAreaModal = true
      this.isShowConditionModal = false
    },
    onClickTargetCondition() {
      this.isShowConditionModal = true
      this.isShowAreaModal = false
    },
    onClickSave(tmpPoiSearchForm) {
      // 直接poiSearchFormに代入すると、「Avoid mutating a prop directly...」warningが出るため親に変更を通知
      this.$emit('update:poiSearchForm', tmpPoiSearchForm)
    },
  },
}
</script>

<style scoped>
.select {
  width: 140px;
  height: 50px;
}
.setting-area-footer {
  padding-top: 20px;
  margin-top: 30px;
  width: 100%;
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 2;
}
.warning-text {
  color: red;
  font-size: 13.5px;
}
.locationList-length-text {
  text-decoration: underline;
  text-decoration-color: black;
}
.container {
  padding-top: 0;
}
</style>
